/**
 * Render a concept node label with KaTeX for tooltip display (DOM context).
 * Falls back to plain label if no LaTeX is detected or KaTeX is unavailable.
 */

import katex from 'katex';

const LATEX_PATTERN = /\$[^$]+\$|\\\([\s\S]+?\\\)|\\\[[\s\S]+?\\\]/;

/**
 * Check if text contains LaTeX delimiters.
 */
export function containsLatex(text) {
  return text && LATEX_PATTERN.test(text);
}

/**
 * Render rawLabel as HTML with KaTeX for inline math.
 * Returns { __html: string } for dangerouslySetInnerHTML, or null if no LaTeX.
 */
export function renderTooltipLabel(rawLabel) {
  if (!rawLabel || !containsLatex(rawLabel)) return null;

  try {
    // Normalize delimiters: \(...\) → $...$, \[...\] → $$...$$
    let text = rawLabel;
    text = text.replace(/\\\[([\s\S]*?)\\\]/g, (_, inner) => `$$${inner}$$`);
    text = text.replace(/\\\(([\s\S]*?)\\\)/g, (_, inner) => `$${inner}$`);

    // Replace $$...$$ (block) and $...$ (inline) with rendered KaTeX
    const html = text.replace(/(\$\$[\s\S]+?\$\$|\$[^\s$][^$]*?[^\s$]\$|\$[^\s$]\$)/g, (match) => {
      const isBlock = match.startsWith('$$') && match.endsWith('$$');
      const inner = isBlock ? match.slice(2, -2).trim() : match.slice(1, -1);
      try {
        return katex.renderToString(inner, {
          displayMode: isBlock,
          throwOnError: false,
          strict: false,
        });
      } catch {
        return match;
      }
    });

    return { __html: html };
  } catch {
    return null;
  }
}
